import React from 'react';
import { Show, TextField, SimpleShowLayout, DateField, BooleanField, ArrayField, SingleFieldList, ChipField } from 'react-admin';
import { ContentPageSX, SimpleShowLayoutSX } from '../../../styled/custom';

const TypePlanShow = props => (
  <Show
    title="Tipos de Plano"
    sx={ContentPageSX}>
    <SimpleShowLayout
      sx={SimpleShowLayoutSX}>
      <TextField source="id" />
      <TextField source="name" label="Nome" />
      <BooleanField source="has_audio" label="Acesso a Áudio" />
      <BooleanField source="has_text" label="Acesso a Texto" />
      <BooleanField source="has_video" label="Acesso a Vídeo" />
      <ArrayField label="Categorias de Mídia Incluídas" source="categories_media">
        <SingleFieldList linkType={false}>
          <ChipField source="name" />
        </SingleFieldList>
      </ArrayField>
      <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} showTime />
    </SimpleShowLayout>
  </Show>
);

export default TypePlanShow;
